import { useTranslate } from '@/hooks/useTranslate';
import { FontAwesomeIcon } from '../Common/FontAwesomeIcon/FontAwesomeIcon';
import { InputTaxComponent } from '../InputTaxComponent/InputTaxComponent';
import { useCallback, useContext, useState } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { ErrorView } from '../Common/Error';
import { CountryCode } from '@/constants/countryCodes';

interface TaxInfoPromptProps {
  onBack: () => void;
  onValidate: (isValid: boolean) => void;
}

export const TaxInfoPrompt = ({ onBack, onValidate }: TaxInfoPromptProps) => {
  const { customer } = useContext(CheckoutContext);
  const { t } = useTranslate();
  const [isValid, setIsValid] = useState(false);

  const countryCode = customer?.taxCountry ?? customer?.geoLocator?.countryCode2;
  const isUSA = countryCode === CountryCode.USA;

  const handleValidate = useCallback(
    (valid: boolean) => {
      setIsValid(valid);
      onValidate(valid);
    },
    [onValidate]
  );

  return (
    <div className="pt-2 flex flex-col gap-2">
      <div onClick={onBack} className="flex flex-row items-center gap-0.5 cursor-pointer">
        <div className="text-sm color-card-foreground font-semibold">
          <FontAwesomeIcon icon="fa-regular fa-chevron-left cursor-pointer mr-2" onClick={onBack} />
          {t('back')}
        </div>
      </div>
      <InputTaxComponent onValidate={handleValidate} />
      {!isValid && (
        <div className="mt-auto">
          <ErrorView message={isUSA ? t('provideValidZipCode') : t('provideValidPostalCode')} />
        </div>
      )}
    </div>
  );
};
